import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_HelloWorld = _resolveComponent("HelloWorld")!
  const _component_about = _resolveComponent("about")!
  const _component_projectSection = _resolveComponent("projectSection")!
  const _component_PricingPlans = _resolveComponent("PricingPlans")!
  const _component_team = _resolveComponent("team")!
  const _component_footerComp = _resolveComponent("footerComp")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NavBar),
    _createVNode(_component_HelloWorld),
    _createVNode(_component_about),
    _createVNode(_component_projectSection),
    _createVNode(_component_PricingPlans),
    _createVNode(_component_team),
    _createVNode(_component_footerComp)
  ], 64))
}